import { atom, useAtom, useAtomValue } from "jotai";
import type { GetPropertyTypesTypeEnum } from "libs/codegen/property-onboarding";

export const propertyCategoryAtom = atom<GetPropertyTypesTypeEnum>();

export const usePropertyCategoryState = () => useAtom(propertyCategoryAtom);
export const usePropertyCategoryValue = () => useAtomValue(propertyCategoryAtom);
